export const redirectNext = (redirectNext) => ({ type: "SET_REDIRECT", redirectNext: redirectNext })
export const set_smscode = (smscode) => ({ type: "SET_SMSCODE", smscode: smscode })
export const set_smserror = (error) => ({ type: "SET_SMS_ERROR", error: error })
export const set_smserrorvalidator = (error) => ({ type: "SET_SMS_ERROR_VALIDATOR", error: error })





// WEBPACK FOOTER //
// src/actions/smsValidationAction.js